export default __webpack_public_path__ + "static/gangbanger-a91799a8646137e123ba678440cb9953.svg";